import { FC } from 'react';
import { ResourcesOption } from '../../types';
import { tailwindOverride } from '@getsynapse/design-system';
import { Typography } from '@getsynapse/design-system';

interface ResourceProps {
  resourcesOption: ResourcesOption;
}

const Resource: FC<ResourceProps> = ({ resourcesOption }) => {
  return (
    <div
      className={tailwindOverride(
        'flex items-center gap-2 w-full justify-start'
      )}
    >
      <img
        src={resourcesOption.iconSrc}
        className={tailwindOverride('text-base w-4 h-4', {
          'group-hover:text-primary': !resourcesOption.disabled,
        })}
        alt='icon'
      />
      <Typography
        className={tailwindOverride(
          'cursor-pointer whitespace-nowrap',
          { 'text-neutral-light': resourcesOption.disabled },
          {
            'group-hover:text-primary': !resourcesOption.disabled,
          }
        )}
        variant='label'
      >
        {resourcesOption.label}
      </Typography>
    </div>
  );
};

export default Resource;
